import { render, staticRenderFns } from "./SimpleLanguages.vue?vue&type=template&id=37bfa05e&scoped=true"
import script from "./SimpleLanguages.vue?vue&type=script&lang=js"
export * from "./SimpleLanguages.vue?vue&type=script&lang=js"
import style0 from "./SimpleLanguages.vue?vue&type=style&index=0&id=37bfa05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bfa05e",
  null
  
)

export default component.exports